import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import styled from 'styled-components';
import FormTitle from './FormTitle';
import CommonButton from './CommonButton';

const NON_LIFE_INSURANCE = [
  '현대해상',
  '흥국화재',
  '삼성화재',
  'DB손해보험',
  '롯데손해보험',
  '메리츠화재',
  'KB손해보험',
  '한화손해보험',
];
const LIFE_INSURANCE = ['교보생명', '한화생명', '삼성생명', 'NH농협생명', '흥국생명', 'ABL생명'];

interface FormType {
  name: string;
  phoneNumber: string;
  insuranceType: string;
  insuranceName: string;
  // address: string;
  hospitalAddress: string;
  accidentType: string;
  insuranceAmount: string;
  description: string;
}

interface InsuranceFormPropsType {
  form: FormType;
  setForm: Dispatch<SetStateAction<FormType>>;
}

const InsuranceForm = ({ form, setForm }: InsuranceFormPropsType) => {
  const [directForm, setDirectForm] = useState('');

  const selectInsuranceType = (type: string) => {
    setForm((prev) => ({
      ...prev,
      insuranceType: type,
      insuranceName: '',
    }));
  };

  const selectInsuranceName = (name: string) => {
    setForm((prev) => ({
      ...prev,
      insuranceName: name,
    }));
  };

  useEffect(() => {
    if (directForm) {
      setForm((prev) => ({
        ...prev,
        insuranceName: directForm,
      }));
    }
  }, [directForm]);

  return (
    <Wrapper>
      <FormTitle title="어떤 보험을 가입하셨나요?" />

      <TypeButtonWrapper>
        <CommonButton
          onClick={() => selectInsuranceType('손해보험')}
          isSelected={form.insuranceType === '손해보험'}
          title="손해보험"
          size="lg"
        />
        <CommonButton
          onClick={() => selectInsuranceType('생명보험')}
          isSelected={form.insuranceType === '생명보험'}
          title="생명보험"
          size="lg"
        />
      </TypeButtonWrapper>

      <InsuranceGrid>
        {form.insuranceType === '손해보험'
          ? NON_LIFE_INSURANCE.map((ins) => (
              <CommonButton
                key={ins}
                onClick={() => selectInsuranceName(ins)}
                isSelected={form.insuranceName === ins}
                title={ins}
                size="sm"
              />
            ))
          : LIFE_INSURANCE.map((ins) => (
              <CommonButton
                key={ins}
                onClick={() => selectInsuranceName(ins)}
                isSelected={form.insuranceName === ins}
                title={ins}
                size="sm"
              />
            ))}
      </InsuranceGrid>

      <StyledInput
        type="text"
        id="place"
        value={directForm}
        onChange={(e) => setDirectForm(e.target.value)}
        placeholder="기타 : 직접 입력해주세요"
      />
    </Wrapper>
  );
};

export default InsuranceForm;

// ======================= styled-components =======================

const Wrapper = styled.div`
  width: 100%;
`;

const TypeButtonWrapper = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
  margin-top: 28px;

  @media (min-width: 640px) {
    gap: 14px;
    margin-top: 22px;
  }
`;

const InsuranceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const StyledInput = styled.input`
  width: 100%;
  margin-top: 12px;
  padding: 10.5px 20px;
  background-color: #f6f7f5;
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  border: none;
  outline: none;

  @media (min-width: 640px) {
    padding: 14px 40px 13px 40px;
    font-size: 18px;
    line-height: 27px;
  }

  &::placeholder {
    font-weight: 300;
    color: #999;
  }

  &:focus {
    border: 1px solid #0b46dd; /* focus:border-blue-200 */
  }
`;
